/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Sample_CoachInputs */

const en_features_sample_coach = /** @type {(inputs: Features_Sample_CoachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kate`)
};

const pl_features_sample_coach = /** @type {(inputs: Features_Sample_CoachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kasia`)
};

/**
* | output |
* | --- |
* | "Kate" |
*
* @param {Features_Sample_CoachInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_sample_coach = /** @type {((inputs?: Features_Sample_CoachInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Sample_CoachInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_sample_coach(inputs)
	return en_features_sample_coach(inputs)
});